import React, { useState } from 'react';
import { ArrowRight, Loader2 } from 'lucide-react';
interface WaitlistFormProps {
  className?: string;
  buttonSize?: 'default' | 'large';
  onSignup?: (email: string) => void;
}
export function WaitlistForm({
  className = '',
  buttonSize = 'default',
  onSignup
}: WaitlistFormProps) {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setIsSubmitting(true);
    await new Promise(resolve => setTimeout(resolve, 1000));
    setIsSubmitting(false);
    if (onSignup) {
      onSignup(email);
    }
    setEmail('');
  };
  return <form onSubmit={handleSubmit} className={`flex flex-col sm:flex-row gap-3 w-full max-w-2xl mx-auto ${className}`} data-id="element-149">
      <input type="email" required placeholder="Enter your work email" value={email} onChange={e => setEmail(e.target.value)} className={`flex-1 min-w-0 px-4 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-900 placeholder:text-slate-500 bg-white shadow-sm ${buttonSize === 'large' ? 'py-4 text-lg' : 'py-3 text-base'}`} data-id="element-150" />
      <button type="submit" disabled={isSubmitting} className={`inline-flex items-center justify-center whitespace-nowrap font-semibold rounded-lg bg-blue-500 text-white hover:bg-blue-400 active:scale-[0.98] transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-70 disabled:cursor-not-allowed shrink-0 ${buttonSize === 'large' ? 'px-8 py-4 text-base' : 'px-6 py-3 text-sm'}`} data-id="element-151">
        {isSubmitting ? <Loader2 className="w-5 h-5 animate-spin mr-2" data-id="element-152" /> : null}
        Signup to Automate my Hiring
        {!isSubmitting && <ArrowRight className="w-5 h-5 ml-2" data-id="element-153" />}
      </button>
    </form>;
}